<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{$t('volver')}}
      </b-button>
      <b-card-header class="border-0">
        <h3 class="mb-0">{{$t('usuario')}} : {{ form.nombre }} {{ form.apellido }}</h3>
      </b-card-header>
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="3">
            <b-form-group label-for="Nombre">
              <template v-slot:label>
                {{$t('nombre')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="nombre" v-model="form.nombre" required :placeholder="$t('ingrese_nombre')"></b-form-input>
            </b-form-group>

            <b-form-group label-for="Contraseña">
              <template v-slot:label>
                {{$t('contrasena')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="password" v-model="form.password" @blur="validatePassword"
                :class="{ 'is-invalid': passwordError }" required :placeholder="$t('ingrese_contrasena')"></b-form-input>
              <b-form-invalid-feedback v-if="passwordError">
                {{ passwordError }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-for="Rut">
              <template v-slot:label>
                {{$t('rut')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="rut" v-model="form.rut" required :placeholder="$t('ingrese_rut')"></b-form-input>
            </b-form-group>

            <b-form-group label-for="Correo">
              <template v-slot:label>
                {{$t('correo')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="correo" v-model="form.correo" required :placeholder="$t('ingrese_correo')"></b-form-input>
            </b-form-group>

            <b-form-group label="Rol" label-for="rolID">
              <template v-slot:label>
                {{$t('rol')}} <span class="text-danger">*</span>
              </template>
              <b-form-select id="rolID" v-model="form.rolID" required>
                <option :value="null" disabled>{{$t('seleccione_opcion')}}</option>
                <option v-for="option in rolesOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>

              </b-form-select>
            </b-form-group>

          </b-col>

          <b-col md="3">
            <b-form-group label-for="Apellido">
              <template v-slot:label>
                {{$t('apellido')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="apellido" v-model="form.apellido" required
              :placeholder="$t('ingrese_apellido')"></b-form-input>
            </b-form-group>
            <b-form-group label="Empresa" label-for="empresaID">
              <template v-slot:label>
                {{$t('empresa')}} <span class="text-danger">*</span>
              </template>
              <b-form-select id="empresaID" v-model="form.empresaID">
                <option :value="null" disabled>{{$t('seleccione_opcion')}}</option>
                <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" variant="primary">
          {{$t('guardar')}}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import usuarioService from '@/api/userService';
import miscService from '@/api/miscService';
export default {
  data() {
    return {
      form: {
        nombre: '',
        apellido: '',
        password: '',
        rut: '',
        correo: '',
        empresaID: null,
        rolID: null
      },
      empresaOptions: [],
      rolesOptions: [],
      passwordError: ''
    };
  },
  async beforeMount() {
    this.rolesOptions = await miscService.getRolesOptions();
    this.empresaOptions = await miscService.getEmpresasOptions();
  },
  methods: {
    async submitForm() {
      try {
        const response = await usuarioService.create(this.form);
        if (!response) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.$t('error')
          });
          return; 
        }

        Swal.fire({
          itle: this.$t('creado_correctamente'),
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          background: '#f8f9fa',
          customClass: {
            title: 'swal-title',
            icon: 'swal-icon',
          },
        });
        this.$router.push(`/usuarios/details/${response.data.id}`);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      }
    },
    validatePassword() {
      if (this.form.password.length < 5) {
        this.passwordError = this.$t('contrasena_caracteres');
      } else {
        this.passwordError = '';
      }
    }

  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
